import { useContext, useEffect, useMemo, useState } from 'react';
import { UserContext } from '@adflow/utils';
import { name as FigmaName, EditorSidebarButton as FigmaSidebarButton } from '@adflow/figma';
import {
  name as MarketingCloudName,
  EditorSidebarButton as MarketingCloudSidebarButton,
  EditorSidebarView as MarketingCloudSidebarView,
} from '@adflow/marketing-cloud';
import {
  name as ShadowBrandName,
  EditorSidebarButton as ShadowBrandSidebarButton,
  EditorSidebarView as ShadowBrandSidebarView,
} from '@adflow/shadow-brand';
import {
  name as CreatomateName,
  EditorSidebarButton as CreatomateSidebarButton,
} from '@adflow/creatomate';

export function useEditorModules() {
  const { user } = useContext(UserContext);
  const isAdmin = user?.isAdmin() ?? false;
  const [offTheShelfTemplatesEnabled, setOffTheShelfTemplatesEnabled] = useState(true);

  useEffect(() => {
    const checkFeature = async () => {
      if (user) {
        const hasFeature = await user.hasFeature('cm-off-the-shelf-templates');
        setOffTheShelfTemplatesEnabled(hasFeature);
      }
    };
    checkFeature();
  }, [user]);

  console.log('isAdmin:', isAdmin, 'offTheShelfTemplatesEnabled:', offTheShelfTemplatesEnabled);

  const modules = useMemo(
    () =>
      isAdmin || !offTheShelfTemplatesEnabled
        ? [
            {
              name: FigmaName,
              EditorSidebarButton: FigmaSidebarButton,
            },
            {
              name: CreatomateName,
              EditorSidebarButton: CreatomateSidebarButton,
            },
            {
              name: ShadowBrandName,
              EditorSidebarButton: ShadowBrandSidebarButton,
              EditorSidebarView: ShadowBrandSidebarView,
            },
            {
              name: MarketingCloudName,
              EditorSidebarButton: MarketingCloudSidebarButton,
              EditorSidebarView: MarketingCloudSidebarView,
            },
          ]
        : [
            {
              name: MarketingCloudName,
              EditorSidebarButton: MarketingCloudSidebarButton,
              EditorSidebarView: MarketingCloudSidebarView,
            },
          ],
    [isAdmin, offTheShelfTemplatesEnabled],
  );

  return { modules };
}
